// cookie banner accept
document.addEventListener("DOMContentLoaded", function () {
    let observer = new MutationObserver((mutations, obs) => {
        let acceptButton = document.getElementById("shopify-pc__banner__btn-accept");
        let cookieBanner = document.getElementById("shopify-pc__banner");

        if (acceptButton && cookieBanner) {
            acceptButton.click();
            obs.disconnect();
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
});



window.egResizeImageHelper = (src, size, crop = '') => src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
        if (crop.length) {
            crop = `_crop_${crop}`;
        }
        return `_${size}${crop}${match}`;
    });

$('.header .menu ul li .sub-menu.mega-menu-column-4 .list-item a').each(function() {
    if ($(this).text().includes('|')) {
        const parts = $(this).text().split('|');
        const title = parts[0];
        let image = (parts[1] || '').trim();
        let description = (parts[2] || '').trim();
        const listItem = $(this).closest('.list-item');

        listItem.removeClass('links');

        // Check if description exists to render the <p> tag
        const descriptionHtml = description ? `<p>${description}</p>` : '';

        image = window.egResizeImageHelper(image.replace(/ /g, ''), '360x');

        $(this).html(`
            <img src="${image}" alt="${title}" height="360" width="300" loading="lazy">
            <div class="list-content">
                <div class="menu-title">${title}</div>
                ${descriptionHtml}
            </div>
        `);
    }
});



$(document).ready(function() {
  const menu = $(".menu");
  const menuMain = menu.find(".menu-main");
  const goBack = menu.find(".go-back");
  const menuTrigger = $(".mobile-menu-trigger");
  const closeMenu = $(".mobile-menu-close");
  let subMenu;

  menuMain.on("click", function(e) {
    if (!menu.hasClass("active")) {
      return;
    }
    if ($(e.target).closest(".menu-item-has-children").length) {
      const hasChildren = $(e.target).closest(".menu-item-has-children");
      showSubMenu(hasChildren);
    }
  });

  goBack.on("click", function() {
    hideSubMenu();
  });

  menuTrigger.on("click", function() {
    toggleMenu();
  });

  closeMenu.on("click", function() {
    toggleMenu();
  });

  $(".menu-overlay").on("click", function() {
    toggleMenu();
  });

  function toggleMenu() {
    menu.toggleClass("active");
    $(".menu-overlay").toggleClass("active");
  }

  function showSubMenu(hasChildren) {
    subMenu = hasChildren.find(".sub-menu");
    subMenu.addClass("active").css("animation", "slideLeft 0.5s ease forwards");
    const menuTitle = hasChildren.find("i").parent().contents().filter(function() {
      return this.nodeType === 3; // Filter for text nodes
    }).text();
    menu.find(".current-menu-title").html(menuTitle);
    menu.find(".mobile-menu-head").addClass("active");
  }

  function hideSubMenu() {
    subMenu.css("animation", "slideRight 0.5s ease forwards");
    setTimeout(function() {
      subMenu.removeClass("active");
    }, 300);
    menu.find(".current-menu-title").html("");
    menu.find(".mobile-menu-head").removeClass("active");
  }

  $(window).on("resize", function() {
    if ($(this).innerWidth() > 991) {
      if (menu.hasClass("active")) {
        toggleMenu();
      }
    }
  });
});